<script setup>
import { ref, watch } from 'vue';

const props = defineProps(['showDialog', 'icon', 'message', 'options']);
const emits = defineEmits(['optionPressed']);

const dialog = ref(false);

const onOptionPressed = (option) => {
    emits('optionPressed', option);
};

watch(
    () => props.showDialog,
    () => {
        dialog.value = props.showDialog;
    },
    { immediate: true }
);
</script>

<template>
    <v-dialog v-model="dialog" :width="500" class="rounded-0" persistent>
        <v-card class="pa-2 rounded-0">
            <v-card-text>
                <v-row>
                    <v-col cols="1">
                        <v-icon
                            size="x-large"
                            color="primary"
                            :icon="icon"
                        ></v-icon>
                    </v-col>
                    <v-col cols="11">
                        {{ message }}
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    v-for="option in options"
                    :key="option"
                    class="text-capitalize rounded-0"
                    :color="option.color"
                    variant="outlined"
                    :loading="option.loading"
                    :disabled="options.some((btn) => btn.loading)"
                    @click="onOptionPressed(option)"
                >
                    {{ $t(option.value) }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
